const frJSON = {
  decathlon_show_filters: 'Afficher les filtres',
  decathlon_hide_filters: 'Cacher les filtres',
  decathlon_reset: 'Effacer',
  decathlon_damAssetCategory_label: 'Catégories',
  decathlon_damPresetView_label: 'Preset View',
  decathlon_topics_label: 'Topics',
  decathlon_rights_label: 'Droits',
  decathlon_domain_label: 'Domaine responsable',
  decathlon_provenance_label: 'Provenance flow',
  decathlon_itemType_label: 'Item type',
  decathlon_sport_label: 'Sports',
  decathlon_brand_label: 'Brand',
  decathlon_productLevel1_label: 'Product level 1',
  decathlon_productLevel2_label: 'Product level 2',
  decathlon_productLevel3_label: 'Product level 3',
  decathlon_productNature_label: 'Product Natures',
  decathlon_productItem_label: 'Articles de produits',
  decathlon_supplierCode_label: 'Fournisseur CNUF',
  decathlon_process_label: 'Process',
  decathlon_componentLevel1_label: 'Component level 1',
  decathlon_componentLevel2_label: 'Component level 2',
  decathlon_componentNature_label: 'Component nature',
  decathlon_language_label: 'Languages',
  decathlon_countryOfDistribution_label: 'Pays',
  decathlon_audience_label: 'Audience',
  decathlon_media_label: 'Media',
  decathlon_selected_filters_label: 'Filtres sélectionnés',
  decathlon_clear_all_filters: 'Supprimer les filtres sélectionnées',
  decathlon_no_matches: 'Nous sommes tristes, rien ne correspond',
  decathlon_try_another_search: 'Veuillez essayer une autre recherche...',
  decathlon_autocomplete_no_options_text: "Pas d'options disponibles",
  decathlon_autocomplete_loading_text: 'Chargement...',
  decathlon_filter_category_label: 'Afficher les documents légaux',
  decathlon_user_menu_label: 'Mon compte',
  decathlon_user_id_label: 'Identifiant',
  decathlon_user_session_started_label: 'Connecté depuis le',
  decathlon_refresh_results_label: 'Actualiser les résultats',
  decathlon_user_language_label: 'Langue',
  decathlon_menu_tooltip: 'Menu',
  decathlon_scroll_to_see_more: "Scroller vers le bas pour voir plus d'items",
  decathlon_go_back_top: 'Top',
  decathlon_sortBy_label: 'Trier par',
  decathlon_sort_newest_label: 'Nouveauté',
  decathlon_sort_oldest_label: 'Ancienneté',
  decathlon_sort_name_a_to_z_label: 'Nom : A à Z',
  decathlon_sort_name_z_to_a_label: 'Nom : Z à A',
  decathlon_sort_revelance_label: 'Pertinence',
  decathlon_archives_label: 'Archives',
  decathlon_actions_label: 'Actions',
  decathlon_file_informations_label: 'Informations du fichier',
  decathlon_content_informations_label: 'Informations détaillées',
  decathlon_createdAt_label: 'Date de création',
  decathlon_name_label: 'Nom du document',
  decathlon_open_label: 'Ouvrir',
  decathlon_download_label: 'Télécharger',
  decathlon_go_back_label: 'Précédent',
  decathlon_master_label: 'Master',
  decathlon_search_label: 'Rechercher…',
  decathlon_results_count: '{{count}} résultats',
  decathlon_results_sentence: 'ont été trouvé',
  decathlon_topic_label: 'Topic',
  decathlon_publisher_label: 'Publié par',
  decathlon_status_label: 'Statut',
  decathlon_internalStatus_label: 'Statut',
  decathlon_internalStatus_Processing_label: 'En traitement',
  decathlon_internalStatus_Activated_label: 'Actif',
  decathlon_internalStatus_Archived_label: 'Archivé',
  decathlon_internalStatus_Error_label: 'Erreur',
  decathlon_internalStatus_Quarantine_label: 'Quarantaine',
  decathlon_internalStatus_Processing_alert_title:
    'Fichier en cours de traitement',
  decathlon_internalStatus_Error_alert_title: 'Fichier indisponible',
  decathlon_internalStatus_Quarantine_alert_title: 'Fichier en quarantaine',
  decathlon_internalStatus_Processing_description:
    "Le fichier est en cours d'analyse et de préparation : il pourra être ouvert et téléchargé dans quelques instants.",
  decathlon_internalStatus_Error_description:
    'Le traitement du fichier a échoué : il ne peut être ni ouvert ni téléchargé.',
  decathlon_internalStatus_Quarantine_description:
    'Le fichier a été isolé par sécurité : il ne peut être ni ouvert ni téléchargé.',
  decathlon_statusReason_FILE_TOO_LARGE_label:
    'Le fichier dépasse la taille maximale autorisée.',
  decathlon_statusReason_FILE_NOT_PDF_label:
    "Le fichier n'est pas un PDF valide.",
  decathlon_statusReason_FILE_PASSWORD_PROTECTED_label:
    "Le fichier est protégé par un mot de passe : l'antivirus ne peut pas l'analyser. Merci de le déposer sans mot de passe.",
  decathlon_statusReason_SOURCE_NOT_FOUND_label:
    'Le fichier déposé est introuvable. Merci de le déposer à nouveau.',
  decathlon_statusReason_SCAN_UNSUPPORTED_label:
    "Le fichier n'a pas pu être analysé par l'antivirus (fichier non pris en charge).",
  decathlon_statusReason_SCAN_ACCESS_DENIED_label:
    "L'antivirus n'a pas pu accéder au fichier.",
  decathlon_statusReason_SCAN_FAILED_label: "L'analyse antivirus a échoué.",
  decathlon_statusReason_SCAN_TIMEOUT_label:
    "L'analyse antivirus ne s'est pas terminée à temps.",
  decathlon_statusReason_IMPORT_FAILED_label: "L'import du fichier a échoué.",
  decathlon_statusReason_TRANSFORMATION_FAILED_label:
    "La génération de l'aperçu et de la vignette a échoué.",
  decathlon_statusReason_PUBLICATION_FAILED_label:
    'La publication publique du fichier a échoué.',
  decathlon_statusReason_PROCESS_START_FAILED_label:
    "Le traitement du fichier n'a pas pu démarrer.",
  decathlon_statusReason_PROCESS_INTERRUPTED_label:
    'Le traitement du fichier a été interrompu avant la fin : déposez à nouveau le fichier.',
  decathlon_statusReason_MALWARE_DETECTED_label:
    'Une menace a été détectée dans le fichier : il a été isolé et ne peut être ni ouvert ni téléchargé.',
  decathlon_file_url_forbidden_error_label:
    "Vous n'avez pas accès à ce fichier, ou il n'est pas disponible pour cette version.",
  decathlon_file_url_error_label:
    'Le fichier est indisponible pour le moment. Merci de réessayer plus tard.',
  decathlon_asset_load_error_label:
    "Ce document n'existe pas ou vous n'y avez pas accès. Il a peut-être été supprimé, ou le lien est incorrect.",
  decathlon_asset_unavailable_title: 'Document indisponible',
  decathlon_asset_unavailable_back_to_search: 'Retour à la recherche',
  decathlon_modifiedAt_label: 'Date de modification',
  decathlon_productModel_label: 'Product Models',
  decathlon_height_label: 'Height',
  decathlon_width_label: 'Width',
  decathlon_creator_label: 'Créateur',
  decathlon_productSuperModelId_label: 'Product SuperModels',
  decathlon_componentModel_label: 'Component model',
  decathlon_componentId_label: 'Component ID',
  decathlon_componentComponentId_label: 'Refpack',
  decathlon_contentId_label: 'Content ID',
  decathlon_componentContentId_label: 'Code IPAC',
  decathlon_componentSuperModel_label: 'Component super model',
  decathlon_carelabel_data_subtitle_label: 'CARELABEL',
  decathlon_carelabel_type_label: 'Carelabel type',
  decathlon_carelabel_version_label: 'Carelabel version',
  decathlon_carelabel_pageNumber_label: 'Carelabel page number',
  decathlon_accessRights_label: 'Access rights',
  decathlon_publicUrl_label: 'Public url',
  decathlon_urlKameleon_label: 'Url kameleon',
  decathlon_filename_label: 'Titre',
  decathlon_file_subtitle_label: 'FICHIER',
  decathlon_linked_products_subtitle_label: 'PRODUITS LIES',
  decathlon_complementary_data_subtitle_label: 'DONNÉES COMPLÉMENTAIRES',
  decathlon_version_label: 'Version',
  decathlon_metadata_more_items_one: '+ {{count}} autre',
  decathlon_metadata_more_items_other: '+ {{count}} autres',
  decathlon_metadata_items_count: '{{shown}} / {{total}}',
  decathlon_metadata_filter_no_result: 'Aucun élément ne correspond',
  decathlon_copy_list_label: 'Copier la liste',
  decathlon_copied_label: 'Copié',
  decathlon_close_label: 'Fermer',
  decathlon_status_page_doesnt_exist:
    "La page que vous recherchez n'existe pas.",
  decathlon_status_go_homepage: "Aller à la page d'accueil"
};

export default frJSON;
